import {
  getAnalyticsConsent,
  trackGoogleAnalyticsEvent,
} from "@/lib/googleAnalytics";

const GA_EVENT_NAMES = {
  view: "page_view",
  play_click: "app_store_click",
  acquista_click: "checkout_intent",
  login_click: "login_intent",
  register_click: "sign_up_intent",
  vip_link_click: "select_content",
  standard_link_click: "select_content",
  vip_compare_click: "view_item_list",
  vip_teaser_click: "view_item_list",
};

export const track = (event, details = {}) => {
  try {
    if (getAnalyticsConsent() !== "granted") return;

    const params = new URLSearchParams({
      e: event,
      s: location.hostname,
      r: document.referrer || "",
      u: location.pathname + location.search,
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`/stat/hit?${params.toString()}`);
    } else {
      fetch(`/stat/hit?${params.toString()}`, { keepalive: true }).catch(() => {});
    }
    trackGoogleAnalyticsEvent(GA_EVENT_NAMES[event] || event, {
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      site_variant: location.hostname.startsWith("vip.") ? "vip" : "standard",
      guardian_action: event,
      ...details,
    });
  } catch {
    // il tracciamento non deve mai bloccare la pagina
  }
};
